import { ParkingState } from '~/store/modules/shared/parking/state'
import { MutationTree } from 'vuex'

import {
  SET_GROUPS,
  SET_CLASSIFIEDS_LIST,
  SET_SEARCHES,
  SET_ERROR,
  REMOVE_SEARCH,
  ADD_TO_SEARCHES,
  REMOVE_CLASSIFIED,
  TOGGLE_RECENT_PARKED,
  SET_LOADING,
  SET_RECENT,
  SET_ACTIVE_TAB,
  CLEAR_NOTIFICATION_FOR_INDEX,
  SET_CLASSIFIED_ORDER,
  SET_CLASSIFIEDS_WITH_NOTIFICATIONS,
  SHOW_PARKING,
  HIDE_PARKING,
  EDIT_CLASSIFIED_LIST,
  FETCH_CLASSIFIED_LISTS_CLASSIFIEDS_BY_ID,
  REMOVE_CLASSIFIED_LIST,
  SET_CLASSIFIED_LIST_ACTION_BUTTONS_LOADING,
  SET_CLASSIFIED_LIST_LOADING,
  DELETE_CLASSIFIED_FROM_CLASSIFIED_LIST,
  REMOVE_LIST_FROM_FAVORITES,
  SET_PARKING_NOTIFICATIONS,
  CLEAR_PARKING_NOTIFICATIONS,
  SET_NOTES_FOR_CLASSIFIED,
  ADD_FAVORITE_CLASSIFIED,
  SET_CATEGORY,
  SET_CLASSIFIED_IS_IN_COMPARISON,
  SET_CLASSIFIED_LIST_CLASSIFIED_IN_COMPARISON
} from './mutation-types'
import { Pagination } from '~/models/search/types'
import { ClassifiedNote } from '~/models/classified/note'
import { ClassifiedList } from '~/models/classified-list/types'
import { vue3Set } from '~/utils/nuxt3-migration'

export default {
  [SET_GROUPS](state, groups) {
    if (!groups) {
      state.groups = {
        classifieds: {
          pagination: { page: 1, total: 0, pageParam: 'pg', perPage: 24 },
          rows: []
        },
        filters: { categories: [] },
        sortOptions: []
      }
      return
    }
    state.groups = groups

    const notifCount =
      state.groups.classifieds.rows.reduce((acc, r) => {
        return acc + (r.notifications.length ? 1 : 0)
      }, 0) || 0

    if (state.groups.filters?.categories) {
      const selectedCategoryId = state.groups.filters.categories.find(
        c => c.selected
      )?.value

      const categoryIndex = state.groups.filters.categories.findIndex(
        c => c.value === selectedCategoryId
      )
      if (categoryIndex !== -1) {
        state.groups.filters.categories[
          categoryIndex
        ].notificationsCount = notifCount
      }
    }
  },
  [SET_CLASSIFIEDS_LIST](state, rows) {
    state.classifiedsList = rows
  },
  [SET_SEARCHES](state, searches) {
    state.searches = searches
  },
  [SET_ERROR](state, errorStatus) {
    state.error = errorStatus
  },
  [REMOVE_SEARCH](state, searchId) {
    if (state.searches) {
      for (let i = 0; i < state.searches.length; i++) {
        if (state.searches[i].query_id === searchId) {
          // eslint-disable-next-line no-console
          state.searches.splice(i, 1)
          return
        }
      }
    }

    return null
  },
  [ADD_TO_SEARCHES](state, searchId) {
    if (state.recent && state.recent.searches) {
      for (let i = 0; i < state.recent.searches.length; i++) {
        if (state.recent.searches[i].query_id === searchId) {
          state.searches && state.searches.push(state.recent.searches[i])
          return
        }
      }
    }

    return null
  },
  [REMOVE_CLASSIFIED](
    state,
    { id, category, listId }: { id: number; category: number; listId: string }
  ) {
    if (state.groups.classifieds?.rows?.length) {
      state.groups.classifieds.rows = state.groups.classifieds.rows.filter(
        r => r.id !== id
      )

      const categoryIndex =
        category === 0
          ? 0
          : state.groups.filters.categories.findIndex(c => c.value === category)
      if (categoryIndex !== -1) {
        state.groups.filters.categories[categoryIndex].count =
          state.groups.filters.categories[categoryIndex].count - 1
      }
    }

    // remove from list
    if (state.classifiedLists.length) {
      setParkingStatus(state.classifiedLists, listId, id, false)
    }

    // remove from order
    for (let i = 0; i < state.classifiedOrder.length; i++) {
      if (state.classifiedOrder[i] === id) {
        state.classifiedOrder.splice(i, 1)
      }
    }

    return null
  },
  [ADD_FAVORITE_CLASSIFIED](
    state,
    { listId, id }: { id: number; listId: string }
  ) {
    if (state.classifiedLists.length) {
      setParkingStatus(state.classifiedLists, listId, id, true)
    }
  },
  [TOGGLE_RECENT_PARKED](state, payload) {
    if (state.recent && state.recent.classifieds.length) {
      for (let i = 0; i < state.recent.classifieds.length; i++) {
        if (state.recent.classifieds[i].id === payload.classifiedId) {
          state.recent.classifieds[i].is_parked = payload.parked
        }
      }
    }
  },
  [SET_LOADING](state, loading) {
    state.loading = loading
  },
  [SET_RECENT](state, recent) {
    state.recent = {
      ...state.recent,
      ...recent
    }
  },
  [SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab
  },
  [SET_CATEGORY](state, cateogry) {
    state.selectedCategory = cateogry
  },
  [CLEAR_NOTIFICATION_FOR_INDEX](state, index) {
    if (state.groups?.filters?.categories) {
      state.groups.filters.categories[index].notificationsCount = 0
    }

    return null
  },
  [SET_CLASSIFIED_ORDER](state, order) {
    state.classifiedOrder = order
  },
  [SET_CLASSIFIEDS_WITH_NOTIFICATIONS](state, withNotifications) {
    state.notificationClassifieds = withNotifications
  },
  [FETCH_CLASSIFIED_LISTS_CLASSIFIEDS_BY_ID](state, { list, classifieds }) {
    const listItemIndex = state.classifiedLists?.findIndex(
      l => l.publicId === list.publicId
    )
    if (state.classifiedLists && listItemIndex > -1) {
      const lists = state.classifiedLists.slice()
      lists[listItemIndex].classifieds = classifieds
      state.classifiedLists = lists
      state.selectedList = lists[listItemIndex]
      lists[listItemIndex].classifiedsCount = classifieds.pagination.total
    } else if (!state.classifiedLists.length && listItemIndex === -1) {
      state.classifiedLists.push(list)
      state.classifiedLists[0].classifieds = classifieds
    } else {
      state.selectedList = list
    }
    state.classifiedsPagination = classifieds.pagination
  },
  [EDIT_CLASSIFIED_LIST](state, list) {
    const listIndex = state.classifiedLists.findIndex(
      l => l.publicId === list.publicId
    )
    list.classifieds = state.classifiedLists[listIndex].classifieds
    vue3Set(state.classifiedLists, listIndex, list)
    state.selectedList = list
  },
  [REMOVE_CLASSIFIED_LIST](
    state,
    { listIdToRemove, classifieds, firstListItem }
  ) {
    const listIndex = state.classifiedLists.findIndex(
      l => l.publicId === listIdToRemove
    )
    state.classifiedLists.splice(listIndex, 1)

    if (firstListItem) {
      firstListItem.classifieds = classifieds
      state.selectedList = firstListItem
      state.classifiedsPagination = classifieds.pagination
    } else {
      state.selectedList = null
      state.classifiedsPagination = {} as Pagination
    }
  },
  [SET_CLASSIFIED_LIST_LOADING](state, loading) {
    state.classifiedListLoading = loading
  },
  [SET_CLASSIFIED_LIST_ACTION_BUTTONS_LOADING](state, loading) {
    state.classifiedListActionButtonsLoading = loading
  },
  [DELETE_CLASSIFIED_FROM_CLASSIFIED_LIST](state, listId) {
    const listIndex = state.classifiedLists.findIndex(
      l => l.publicId === listId
    )
    state.classifiedLists[listIndex].classifiedsCount--
  },
  [REMOVE_LIST_FROM_FAVORITES](state, listId) {
    state.classifiedLists = state.classifiedLists.filter(
      c => c.publicId !== listId
    )
  },
  [SHOW_PARKING](state) {
    state.showParking = true
    state.parkUrlBefore = window.location.href
  },
  [HIDE_PARKING](state) {
    state.showParking = false
    state.parkUrlBefore = ''
  },
  [SET_PARKING_NOTIFICATIONS](state, count) {
    state.parkingNotifications = count
  },
  [CLEAR_PARKING_NOTIFICATIONS](state) {
    state.parkingNotifications = 0
  },
  [SET_NOTES_FOR_CLASSIFIED](
    state,
    { note, clsfdId }: { note: ClassifiedNote | null; clsfdId: number }
  ) {
    // set for groups
    if (state.groups.classifieds.rows.length) {
      const rowIndex = state.groups.classifieds.rows.findIndex(
        r => r.id === clsfdId
      )
      if (rowIndex !== -1) {
        state.groups.classifieds.rows[rowIndex].notes = note
      }
    }

    // set for list
    if (state.classifiedsList) {
      for (let i = 0; i < state.classifiedsList.length; i++) {
        if (state.classifiedsList[i].id === clsfdId) {
          state.classifiedsList[i].notes = note
        }
      }
    }
  },
  [SET_CLASSIFIED_IS_IN_COMPARISON](
    state,
    {
      classifiedId,
      isInComparison
    }: { classifiedId: number; isInComparison: boolean }
  ) {
    if (state.groups.classifieds.rows.length) {
      const row = state.groups.classifieds.rows.find(r => r.id === classifiedId)
      if (row) {
        row.compare.is_in_comparison = isInComparison
      }
    }
  },
  [SET_CLASSIFIED_LIST_CLASSIFIED_IN_COMPARISON](
    state,
    {
      classifiedId,
      listId,
      isInComparison
    }: { classifiedId: number; listId: string; isInComparison: boolean }
  ) {
    if (state.classifiedLists.length) {
      const list = state.classifiedLists.find(l => l.publicId === listId)
      if (list && list.classifieds.rows?.length) {
        const classified = list.classifieds.rows.find(
          c => c.id === classifiedId
        )
        if (classified) {
          classified.compare.is_in_comparison = isInComparison
        }
      }
    }
  }
} as MutationTree<ParkingState>

function setParkingStatus(
  lists: ClassifiedList[],
  listId: string,
  cid: number,
  status: boolean
) {
  const list = lists.find(cl => cl.publicId === listId)
  if (!list) {
    return
  }
  const classified = list.classifieds.rows?.find(c => c.id === cid)
  if (classified) {
    classified.is_parked = status
  }
}
